// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__UDWeb","col":"styles_col__1_wA0","fulfillmentStatus":"styles_fulfillmentStatus__Utach","emailCol":"styles_emailCol__1yB-A"};